export default "__VITE_ASSET__b2ce4c34__"